// Debug utility for theme functionality

export const debugTheme = () => {
  if (typeof window === "undefined") return;

  const root = document.documentElement;
  const currentTheme = root.classList.contains("dark") ? "dark" : "light";
  const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

  console.log("🎨 Theme Debug Info:");
  console.log("Current DOM theme:", currentTheme);
  console.log("System preference:", systemTheme);
  console.log("Dark class present:", root.classList.contains("dark"));
  console.log("All classes:", root.className);
};

// Make it available globally for debugging
if (typeof window !== "undefined") {
  (window as Window & { debugTheme?: () => void }).debugTheme = debugTheme;
}